<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.cantEmbarazos"
          label="Cantidad de embarazos"
          prepend-icon="mdi-hospital"
          required
          :rules="requiredRules"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.cantNacimientos"
          label="Cantidad de nacimientos *"
          prepend-icon="mdi-hospital"
          required
          :rules="requiredRules"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.cantHijos"
          label="Cantidad de hijos"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-textarea
          prepend-icon="mdi-hospital"
          v-model="values.observaciones"
          label="Evolucion *"
          :rules="requiredRules"
          clearable
          auto-grow
        >
        </v-textarea>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import evolucionJsonMixin from "../../../../mixins/evolucionJsonMixin";
export default {
  data() {
    return {
      values: {
        cantEmbarazos: null,
        cantNacimientos: null,
        cantHijos: null,
        observaciones: "",
      },
    };
  },
  mixins: [evolucionJsonMixin],
  computed: {
    camposRequeridos() {
      return !(!!this.values.cantNacimientos && !!this.values.cantEmbarazos);
    },
  },
};
</script>
